import React from "react";
import VerificationErrorComponent from "src/components/errors/VerificationErrorComponent";
import { useTranslation } from "react-i18next";

const Decline = () => {
  const { t } = useTranslation();
  const returnUrl = sessionStorage.getItem("returnUrl") === "null" ? null : sessionStorage.getItem("returnUrl");

  const props = {
    title: t('decline.title'),
    subtitle: t('decline.subtitle'),
    footerText: t('decline.footer'),
    buttonTitle: returnUrl ? t('success.goHome') : null,
    buttonHref: returnUrl || null,
    largeFooterText: true,
  };

  return <VerificationErrorComponent {...props} />;
};

export default Decline;
